/* eslint-disable jsx-a11y/label-has-associated-control */
// TODO: convert error msg to Alert
import { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Stack, TextField, useTheme } from '@mui/material';
import { AxiosError } from 'axios';
import useAuth from '../../../hooks/useAuth';
import useInput from '../../../hooks/useInput';
import axios from '../../../api/axios';

import vertexLogo from '../../../global/Images/Vertex-VPS-Logo.png';

import './login.css';

const Login = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();

  const userRef = useRef<HTMLInputElement>(null);
  // const errRef = useRef<HTMLParagraphElement>(null);

  const [user, resetUser, userAttribs] = useInput('user', '');
  const [pwd, setPwd] = useState('');
  const [errMsg, setErrMsg] = useState('');

  useEffect(() => {
    setErrMsg('');
  }, [user, pwd]);

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/auth`,
        JSON.stringify({ user, pwd }),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        },
      );
      const accessToken = response?.data?.accessToken;
      const roles = response?.data?.roles;
      const aiTrainingComplete = response?.data?.ai_training_completed;
      setAuth({ user, accessToken, roles, aiTrainingComplete });
      resetUser();
      setPwd('');

      navigate('/home', {
        replace: true,
        state: { authenticated: true },
      });
    } catch (err) {
      if (err instanceof AxiosError) {
        if (!err?.response) {
          setErrMsg('No Server Response');
        } else if (err.response?.status === 400) {
          setErrMsg('Missing Username or Password');
        } else if (err.response?.status === 401) {
          setErrMsg('Unauthorized');
        } else {
          setErrMsg('Login Failed');
        }
        // errRef?.current?.focus();
      }
    }
  };

  return (
    <Box className="full-screen-container">
      <Box className="login-container">
        <Box
          component="img"
          alt="Vertex Professional Services"
          src={vertexLogo}
        />
        {errMsg.length > 0 && (
          <Stack sx={{ mt: theme.spacing(3) }} spacing={2}>
            <Alert
              severity="error"
              onClose={() => {
                setErrMsg('');
              }}
            >
              {errMsg}
            </Alert>
          </Stack>
        )}
        <Box component="form" className="form" onSubmit={handleSubmit}>
          <TextField
            type="text"
            id="username"
            label="UserName:"
            variant="filled"
            inputRef={userRef}
            autoComplete="off"
            sx={{
              backgroundColor: theme.brandcolor.primaryLight,
              marginTop: '1rem',
            }}
            error={!!errMsg}
            // helperText={errMsg}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...userAttribs}
            required
          />

          <TextField
            type="password"
            id="password"
            label="Password"
            variant="filled"
            sx={{ backgroundColor: theme.brandcolor.primaryLight }}
            onChange={(e) => setPwd(e.target.value)}
            value={pwd}
            error={!!errMsg}
            // helperText={errMsg}
            required
          />

          <Button type="submit" variant="contained" className="login-button">
            Sign In
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
